var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 34,
    viewBox: "0 0 24 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9358 26.2722L16.3838 19.7202C16.1038 19.4402 15.7118 19.2722 15.3198 19.3282H15.2638H10.7838V17.1442H15.0958C15.5998 17.1442 15.9918 16.7522 15.9918 16.2482C15.9918 15.7442 15.5998 15.3522 15.0958 15.3522H10.7838V9.69621C10.7838 8.52021 9.83181 7.51221 8.65581 7.51221C7.47981 7.51221 6.52781 8.46421 6.52781 9.69621V14.7362C3.16781 16.1922 0.759811 19.5522 0.759811 23.5282C0.759811 28.7922 5.01581 33.0482 10.2798 33.0482C14.4798 33.0482 18.0078 30.3602 19.2958 26.6082L20.9758 28.2882C21.5358 28.8482 22.4318 28.8482 22.9358 28.2882C23.4958 27.7282 23.4958 26.8322 22.9358 26.2722ZM10.2798 30.8082C6.24781 30.8082 2.99981 27.5602 2.99981 23.5282C2.99981 20.8402 4.45581 18.5442 6.58381 17.2562V20.5042C6.58381 20.6162 6.58381 20.6722 6.58381 20.7282C6.58381 20.7842 6.58381 20.8962 6.58381 20.9522C6.58381 21.9042 7.31181 22.6322 8.26381 22.6322H15.2638C15.3198 22.6322 15.3198 22.6322 15.3758 22.6322L17.4478 24.7042C16.8878 28.1762 13.8638 30.8082 10.2798 30.8082Z",
    fill: "#CEB96F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71205 6.61612C10.5059 6.61612 11.9601 5.16194 11.9601 3.36812C11.9601 1.5743 10.5059 0.120117 8.71205 0.120117C6.91823 0.120117 5.46405 1.5743 5.46405 3.36812C5.46405 5.16194 6.91823 6.61612 8.71205 6.61612Z",
    fill: "#CEB96F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.e6e5f5eb65a90b18fe943fcf883389f3.svg";
export { ForwardRef as ReactComponent };